import(/* webpackMode: "eager" */ "/vercel/path0/src/app/contests/page.tsx");
